import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { AfterViewInit, QueryList, ViewChildren, ElementRef, ViewChild, HostListener } from '@angular/core';

@Component({
    selector: 'app-about-page',
    templateUrl: './about-page.component.html',
    styleUrls: ['./about-page.component.scss']
})
export class AboutPageComponent implements OnInit {
    @ViewChildren('revealEl', { read: ElementRef }) revealEls!: QueryList<ElementRef>;

    @ViewChild('heroBanner') heroBanner!: ElementRef;
    @ViewChild('heroTitle') heroTitle!: ElementRef;


    features = [
    {
      number: '01',
      title: 'Premium Quality',
      description: 'Every toy is carefully selected and tested for long-lasting durability and endless fun.',
      image: '../assets/img/slider/cardimg1.png',
      image1: '../assets/img/slider/cardimg11.png',
      cardClass: 'premium'
    },
    {
      number: '02',
      title: 'Kid Safe',
      description: 'Made from non-toxic, child-friendly materials with safety as our top priority.',
      image: '../assets/img/slider/cardimg2.png',
       image1: '../assets/img/slider/cardimg22.png',
      cardClass: 'safe'
    },
    {
      number: '03',
      title: 'Fast Delivery',
      description: 'Quick shipping and secure packaging for a delightful unboxing experience.',
      image: '../assets/img/slider/cardimg3.png',
       image1: '../assets/img/slider/cardimg33.png',
      cardClass: 'delivery'
    },
    {
      number: '04',
      title: 'Easy Returns',
      description: 'Simple return process backed by responsive customer support whenever you need.',
      image: '../assets/img/slider/cardimg4.png',
       image1: '../assets/img/slider/cardimg44.png',
      cardClass: 'returns'
    }
  ];
 
  trustPoints = [
    { icon: 'assets/img/toy_icons/icon_2.png', text: 'Trusted by Thousands of Parents' },
    { icon: 'assets/img/toy_icons/icon_4.png', text: '100% Genuine Products' },
    { icon: 'assets/img/toy_icons/icon_10.png', text: 'Secure Payments You Can Trust' },
    { icon: 'assets/img/toy_icons/icon_6.png', text: 'Happiness Guaranteed' }
  ];



    missionPoints = [
    'Safe and age-appropriate toys',
    'Quality parents can trust',
    'Fun in every box'
  ];
 
  visionPoints = [
    'Trusted by families',
    'Toys that inspire learning',
    'Happy moments that last'
  ];

    constructor(private meta: Meta, private titleService: Title) { }

    ngOnInit(): void {
        this.titleService.setTitle(
            'Sangeetha Toys | Premium Toys, Games & Educational Playsets'
        );

        this.meta.updateTag({
            name: 'description',
            content: 'Sangeetha Toys offers a wide range of premium toys, educational games, action figures, dolls, puzzles, toy vehicles, and creative playsets designed to inspire learning, imagination, and fun for children of all ages.'
        });
    }

    getIconForTitle(title: string): string {
        switch (title.toLowerCase()) {
            case 'our goal':
                return 'bx-target-lock';
            case 'our mission':
                return 'bx-compass';
            case 'our vision':
                return 'bx-bulb';
            default:
                return 'bx-bulb';
        }
    }

    pageTitle = [
        {
            bgImage: 'assets/img/About.jpg',
            title: 'Leading Fire Safety Solutions Provider in Qatar'
        }
    ]

    aboutContent = [
        {
            subTitle: "ABOUT KITCHEN MAGIC",
            image: 'assets/img/about-img-1.jpg',
            title: "Welcome to our kitchen",
            paragraph: "Kitchen Magic was born from family, tradition, and the unforgettable memories created around food. Founded by Nagarajan Murugan, who was born and raised in Kanyakumari district, Tamil Nadu, Kitchen Magic is inspired by the warmth of village-style cooking and the love shared through homemade meals. Growing up in a humble lower middle-class family, Nagarajan’s passion for cooking came from watching his father, Murugan, cook special weekend meals while his mother, Kala, added her own magical finishing touch with freshly ground spices and secret seasonings.",
            chefImage: 'assets/img/chef.jpg',
            chefName: 'Chef Aravind',
            chefRole: 'Head Chef & Culinary Artist',
            chefDescription: `
                    With over 15 years of experience in authentic South Indian cuisine,
                    Chef Aravind blends traditional recipes with modern presentation.
                    His passion for fresh ingredients and live cooking creates a magical
                    dining experience for every guest.
                `,
            content: [
                // {
                //     title: "Our Goal",
                //     paragraph: "Our goal is to be a trusted leader in fire protection systems across Qatar by providing end-to-end fire safety solutions. We aim to deliver reliable systems and services that ensure maximum safety, compliance, and peace of mind for our clients."
                // },
                {
                    title: "Our Mission",
                    paragraph: "Our mission is to create memorable food experiences rooted in tradition, family, and heartfelt hospitality. Blending authentic South Indian flavors with modern culinary creativity, we bring people together through fresh ingredients, live cooking, and the warm “magic” that makes every visit truly special.."
                },
                {
                    title: "Our Vision",
                    paragraph: "To build Kitchen Magic into a globally recognized food brand with food trucks, cloud kitchens, and restaurants that serve authentic flavors using quality, sustainable, and nature-friendly practices."
                }
            ]
        }
    ]

    Content = {

    };
    aboutImage = [
        {
            img: '../../../../assets/img/about3.jpg'
        },
        {
            img: '../../../../assets/img/about4.jpg'
        }
    ]

    ngAfterViewInit() {

        this.handleScroll();
        setTimeout(() => {
            const elements = document.querySelectorAll('.reveal');

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('active');
                    } else {
                        entry.target.classList.remove('active');
                    }
                });
            }, { threshold: 0.2 });

            elements.forEach(el => observer.observe(el));
        }, 200);
    }


    @HostListener('window:scroll', [])
    handleScroll() {
        const scrollY = window.scrollY;

        // Background zoom (slow)
        const scale = 1 + scrollY * 0.0004;

        // Title parallax (faster for depth)
        const titleMove = scrollY * 0.3;

        this.heroBanner.nativeElement.style.transform =
            `scale(${scale})`;

        this.heroTitle.nativeElement.style.transform =
            `translateY(${titleMove}px) scale(${1 + scrollY * 0.0002})`;
    }


}